import { FC, ImgHTMLAttributes } from "react";

const Image: FC<{ name: string } & ImgHTMLAttributes<HTMLImageElement>> = ({
  name,
  alt,
  src,
  ...restProps
}) => (
  <img
    {...restProps}
    alt={alt || ""}
    src={src || `${import.meta.env.REACT_APP_STATIC_URL}/images/${name}`}
    data-categories="essential"
  />
);

export default Image;
